import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DtnService from '../../../services/DtnService';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import moment from 'moment';
import FormInputText from '../../_shared/forms/FormInputText';
import DatePicker from 'react-datepicker';
import FormError from '../../_shared/forms/FormError';
import FormMultiSelect, { SearchableSelect } from '../../_shared/forms/FormMultiSelect';
import JobExtras from '../../Jobs/JobExtras';
import DtnPhotos from '../../Jobs/dtn/paritals/DtnPhotos';
import SubmitButton from '../../_shared/SubmitButton';
import PricingDetails from './partials/PricingDetails';
import CustomerDetails from './partials/CustomerDetails';

class CreateProviderJobDtn extends Component {
    constructor(props) {
        super(props);
        let { job, dtn, type } = this.props;

        let collectionDate = dtn.collection_date ? new Date(dtn.collection_date) : '';
        let beforeLoadingWaste = type.before_loading_waste ? new Date(type.before_loading_waste) : '';
        let afterLoadingWaste = type.after_loading_waste ? new Date(type.after_loading_waste) : '';

        let tipOffOptions = [...this.props.tipOffOptions];

        let tipOff = tipOffOptions.find((tipOff) => {
            return tipOff.value === this.props.job.tip_off_id;
        });

        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collectionDate,
            before_loading_waste: beforeLoadingWaste,
            after_loading_waste: afterLoadingWaste,
            waste_collected: type.waste_collected,
            waste_contained: 'Skip',
            waste_description: 'General Mixed Waste 20 03 01',
            waste_volume: type.waste_volume,
            extrasOptions: this.props.jobExtras || '',
            selectedExtras: job.job_extras || '',
            jobTypePrice: 0,
            totalPrice: 0,
            providerJobTypePrice: 0,
            providerTotalPrice: 0,
            loading: false,
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            rejected_files: {},
            errors: {},
            tipOff: typeof tipOff !== 'undefined' ? tipOff : [],
            provider_quantity: job.provider_quantity || 0,
            quantity: job.quantity || 0,
            admin_notes: job.admin_notes || '',
            purchase_order_number: job.purchase_order_number || '',
            purchase_order_total: job.purchase_order_total || 0,
            sla: job.sla || '',
            price_quoted: job.price_quoted === 1 ? 'yes' : 'no',
            custom_price: job.custom_price || 0,
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : 0,
            disable_status_buttons: false,
            provider_price_quoted: job.provider_price_quoted === 1 ? 'yes' : 'no',
            provider_custom_price: job.provider_custom_price || '',
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
            created_by: this.props.serviceProvider.name,
        };
        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        let providerJobTypePrice = this.setProviderJobTypePrice();

        this.calculateTotalPrice(jobTypePrice, providerJobTypePrice);
    }

    jobNotTippedModal = () => {
        window.swal.fire({
            title: `Waste not tipped`,
            text: ``,
            type: 'info',
            confirmButtonText: `Ok`,
        });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot ? jobType.pivot.price : jobType.default_price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    setProviderJobTypePrice = () => {
        let providerJobType = this.props.serviceProvider.job_types.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });
        let providerJobTypePrice;

        //If provider does not have job type available, use global job type default price
        if (typeof providerJobType !== 'undefined') {
            providerJobTypePrice = providerJobType.pivot ? providerJobType.pivot.price : providerJobType.default_price;
        } else {
            providerJobType = this.props.jobTypes.find((jobType) => {
                return jobType.id === this.props.job.job_type_id;
            });
            providerJobTypePrice = providerJobType.provider_default_price || 0;
        }

        this.setState({
            providerJobTypePrice: providerJobTypePrice,
        });

        return providerJobTypePrice;
    };

    calculateTotalPrice = (jobTypePrice, providerJobTypePrice) => {
        let totalPrice = jobTypePrice * this.state.quantity;
        let providerTotalPrice = providerJobTypePrice * this.state.provider_quantity;

        if (this.state.selectedExtras) {
            this.state.selectedExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                providerTotalPrice += Number(extra.providerPrice) * Number(extra.provider_quantity || 0);
            });
        }

        this.setState({
            totalPrice: totalPrice / 100,
            providerTotalPrice: providerTotalPrice / 100,
        });
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    handleChange = (e) => {
        let { name, value, type } = e.target;

        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (type === 'checkbox') {
            value = this.state[name] === 'yes' ? 'no' : 'yes';
        }

        this.setState(
            {
                [name]: value,
                errors: errorsObject,
            },
            () => {
                if (name === 'provider_quantity' || name === 'quantity') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];

        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];

            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }

            if (
                !extras[extras.length - 1].hasOwnProperty('provider_quantity') ||
                extras[extras.length - 1].provider_quantity === ''
            ) {
                extras[extras.length - 1].provider_quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][e.target.name] = e.target.value;

        if (e.target.name === 'quantity') {
            extras[extraIndex]['provider_quantity'] = e.target.value;
        }

        if (extra.singular) {
            extras[extraIndex][e.target.name] = e.target.value;
        }

        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    handleSearchableSelectChange = (e, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({
            [name]: e,
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };

    onSubmit = (e) => {
        e.preventDefault();
        let errors = {};
        const photoFields = ['images_before', 'images_after'];

        photoFields.forEach((photoField) => {
            const uploadedCount = (this.state[photoField] && this.state[photoField].length) || 0;
            const existingCount = (this.props.media[photoField] && this.props.media[photoField].length) || 0;
            const totalPhotos = uploadedCount + existingCount;

            if (totalPhotos < 2) {
                errors[photoField] = `${snakeCaseToTitle(photoField)} must include at least 2 photos`;
            }
        });

        this.setState({ errors: {} });
        if (this.props.dtn.id) {
            this.onSubmitValidateUpdate(e);
        } else {
            this.onSubmitValidateStore(e);
        }
    };

    onSubmitValidateStore = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();
            this.dtnService
                .storeProviderDtn(this.props.serviceProvider.id, this.props.job.id, formData)
                .then((res) => {
                    // Stop spinner
                    this.setState({ loading: false });
                    toastr.success('Wtn was successfully saved');

                    location = this.props.redirectAllocated;
                })
                .catch(() => {
                    // Stop spinner
                    this.setState({ loading: false });
                    toastr.error('There was a problem while submitting the form. Please try again.');
                });
        }
    };

    onSubmitValidateUpdate = (e) => {
        if (this.validateForm()) {
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();
            const oldProviderQuantity = parseInt(this.props.job.provider_quantity, 10) || 0;
            const newProviderQuantity = parseInt(formData.get('provider_quantity'), 10) || oldProviderQuantity;
            const providerJobTypePrice = parseFloat(this.state.providerJobTypePrice) || 0;
            const newProviderTotalPrice = providerJobTypePrice * newProviderQuantity;
            formData.append('new_provider_total_price', newProviderTotalPrice);
            const providerId = this.props.job.service_provider_id;
            const jobId = this.props.job.id;

            this.dtnService
                .updateProviderDtn(providerId, jobId, formData)
                .then((res) => {
                    this.setState({ loading: false });
                    toastr.success('Wtn was successfully edited');

                    window.location.href = `/providers/${providerId}/jobs/review`;
                })
                .catch(() => {
                    this.setState({ loading: false });
                    toastr.error('There was a problem while submitting the form. Please try again.');
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
            'tipOff',
        ];

        if (this.state.price_quoted === 'yes') {
            fields.push('custom_price');
        }

        if (this.state.provider_price_quoted === 'yes') {
            fields.push('provider_custom_price');
        }

        // if (!this.props.dtn.id) {
        //     fields.push('route_started');
        //     fields.push('route_arrived');
        //     fields.push('first_operative');
        //     fields.push('job_completed');
        // }

        fields.map((field) => {
            if (field === 'tipOff') {
                if (!this.state.tipOff || Object.keys(this.state.tipOff).length === 0 || !this.state.tipOff.value) {
                    errors.tipOff = 'Tip off field is required';
                }
            } else if (this.state[field] === '' || this.state[field] === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
            'job_notes',
            'selectedExtras',
            'provider_quantity',
            'quantity',
            'admin_notes',
            'sla',
            'purchase_order_number',
            'purchase_order_total',
            'custom_price',
            'price_quoted',
            'provider_price_quoted',
            'provider_custom_price',
            'created_by',
        ];

        // if (!this.props.dtn.id) {
        //     mappable.push('route_started');
        //     mappable.push('route_arrived');
        //     mappable.push('job_completed');
        // }

        formData.append('job_extras', JSON.stringify(this.state.selectedExtras));
        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        formData.append('tip_off_id', this.state.tipOff.value || '');

        formData.append('quantity', this.state.waste_volume);
        formData.append('provider_quantity', this.state.waste_volume);
        formData.append('total_waste_removed', this.state.waste_collected || 0);
        formData.append('estimate_waste_removed', this.state.waste_volume || 0);

        mappable.forEach((input) => {
            if (
                input === 'collection_date' ||
                input === 'route_started' ||
                input === 'route_arrived' ||
                input === 'job_completed'
            ) {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            if (input === 'before_loading_waste' || input === 'after_loading_waste') {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });

        return formData;
    };

    render() {
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} className="transform-text">
                    <CustomerDetails
                        customer={this.props.job.customer.name}
                        customer_contact={this.props.job.contact.first_name + ' ' + this.props.job.contact.last_name}
                        job_source={this.props.job_source ? this.props.job_source.job_source : ''}
                        purchase_order_number={this.state.purchase_order_number}
                        purchase_order_total={this.state.purchase_order_total}
                        sla={this.state.sla}
                        department={this.props.job.contact ? this.props.job.contact.department.name : ''}
                        handleChange={this.handleChange}
                    />

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="address"
                                label="Address line 1"
                                value={this.state.address}
                                classes={this.state.errors.address ? 'form-control is-invalid' : 'form-control'}
                                disabled
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="postcode"
                                label="Postcode"
                                value={this.state.postcode}
                                classes={this.state.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                disabled
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <SearchableSelect
                                name="tip_offs"
                                classes={this.state.errors.tipOff ? 'is-invalid' : ''}
                                options={this.props.tipOffOptions}
                                value={this.state.tipOff}
                                error={this.state.errors.tipOff}
                                handleChange={(e) => this.handleSearchableSelectChange(e, 'tipOff')}
                                label="Select tip off"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Collection date</label>
                            <DatePicker
                                className={
                                    this.state.errors.collection_date ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="collection date"
                                selected={this.state.collection_date || null}
                                onChange={(date) => this.handleDateChange(date, 'collection_date')}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                            <FormError error={this.state.errors.collection_date} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time before loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.before_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time before loading the waste"
                                selected={this.state.before_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'before_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.before_loading_waste} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time after loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.after_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time after loading the waste"
                                selected={this.state.after_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'after_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.after_loading_waste} />
                        </div>
                    </div>

                    <div className="row hidden">
                        <div className="form-group col-md-12">
                            <label>Admin notes</label>
                            <textarea
                                className="form-control"
                                name="admin_notes"
                                id="admin_notes"
                                value={this.state.admin_notes}
                                onChange={this.handleChange}
                                placeholder="Admin notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste collected</h6>
                        </div>
                    </div>

                    <div className="row hidden">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_contained"
                                label="How was the waste contained:"
                                value="Skip"
                                classes="form-control"
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_description"
                                label="Description of the waste being collected:"
                                value={this.state.waste_description}
                                classes={
                                    this.state.errors.waste_description ? 'form-control is-invalid' : 'form-control'
                                }
                                error={this.state.errors.waste_description}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_volume"
                                label="How much waste have you collected in cubic yards?:"
                                value={this.state.waste_volume}
                                classes={this.state.errors.waste_volume ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_volume}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_collected"
                                label="Estimated weight of waste collected(Kg):"
                                value={this.state.waste_collected}
                                classes={this.state.errors.waste_collected ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_collected}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Did you collect anything else?"
                                options={this.state.extrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedExtras')
                                }
                                classes={'form-control'}
                                prefixes={this.state.selectedExtras}
                            />
                        </div>
                    </div>

                    <JobExtras
                        extras={this.state.selectedExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedExtras'}
                        extrasPrices={this.props.jobExtras}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'job_extras'}
                        dtn={true}
                        hideFields={true}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />
                    <FormError error={this.state.errors.images_before} />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />
                    <FormError error={this.state.errors.images_after} />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <SubmitButton
                        buttonText={this.props.dtn.id ? 'Edit WTN' : 'Create WTN'}
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 20 }}
                    />
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('create-provider-dtn')) {
    const element = document.getElementById('create-provider-dtn');

    ReactDOM.render(
        <CreateProviderJobDtn
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            media={JSON.parse(element.dataset.media)}
            jobTypes={JSON.parse(element.dataset.job_types)}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            serviceProvider={JSON.parse(element.dataset.service_provider)}
            redirectAllocated={element.dataset.redirectAllocated}
            operatives={element.dataset.operatives ? JSON.parse(element.dataset.operatives) : []}
        />,
        element
    );
}

export default CreateProviderJobDtn;
